import { gql } from '@/__generated__';

const UPDATE_USER_COLLECTION_RELATIONS = gql(`#graphql
  mutation UpdateUserCollectionRelations($accountId: Int!, $inputs: [UpdateUserCollectionRelationInput!]!) {
    updateUserCollectionRelations(accountId: $accountId, inputs: $inputs) {
      updatedCollectionIds
    }
  }
`);

export default UPDATE_USER_COLLECTION_RELATIONS;
